import { render } from "./fleetList.vue?vue&type=template&id=45513470&scoped=true"
import script from "./fleetList.vue?vue&type=script&lang=js"
export * from "./fleetList.vue?vue&type=script&lang=js"

import "./fleetList.vue?vue&type=style&index=0&id=45513470&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45513470"]])